// There's a natural semantic order in these objects (in order of size of the
// date/time unit), so disabling alphabetical sorting.
/* eslint-disable sort-keys */

// Date formats
const defaultDate: Intl.DateTimeFormatOptions = {
  weekday: "short",
  day: "numeric",
  month: "short",
  year: "numeric",
};
const weekdayDayAndMonth: Intl.DateTimeFormatOptions = {
  weekday: "short",
  day: "numeric",
  month: "short",
};
const monthAndYear: Intl.DateTimeFormatOptions = {
  month: "long",
  year: "numeric",
};

// Time formats
const defaultTime: Intl.DateTimeFormatOptions = {
  hour: "numeric",
  minute: "numeric",
};

// Date-time formats
const full: Intl.DateTimeFormatOptions = {
  dateStyle: "full",
  timeStyle: "short",
};

export const dateFormats = {
  default: defaultDate,
  monthAndYear,
  weekdayDayAndMonth,
};
export const timeFormats = { default: defaultTime };
export const dateTimeFormats = { date: dateFormats, time: timeFormats, full };
